import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltCommentDialogAgentSuggestionAgentAvatarWireframe from './VeltCommentDialogAgentSuggestionAgentAvatarWireframe/VeltCommentDialogAgentSuggestionAgentAvatarWireframe';
import VeltCommentDialogAgentSuggestionAgentNameWireframe from './VeltCommentDialogAgentSuggestionAgentNameWireframe/VeltCommentDialogAgentSuggestionAgentNameWireframe';
var VeltCommentDialogAgentSuggestionAgentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-agent-suggestion-agent-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogAgentSuggestionAgentWireframe.Avatar = VeltCommentDialogAgentSuggestionAgentAvatarWireframe;
VeltCommentDialogAgentSuggestionAgentWireframe.Name = VeltCommentDialogAgentSuggestionAgentNameWireframe;
export default VeltCommentDialogAgentSuggestionAgentWireframe;
